import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import { LanguageRefresh } from './i18n/LanguageRefresh';
import App from './App';
import reportWebVitals from './reportWebVitals';

// これ以降の chunk 失敗は React 側で扱う。エントリ自体が読めないときは index.html が扱う。
(window as Window & { __NOTREU_APP_BOOTED__?: boolean }).__NOTREU_APP_BOOTED__ = true;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <LanguageRefresh>
    {import.meta.env.MODE === 'development' ? (
      <App />
    ) : (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )}
  </LanguageRefresh>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
